import { render, staticRenderFns } from "./question-card-v2.vue?vue&type=template&id=29efe74b&scoped=true"
import script from "./question-card-v2.vue?vue&type=script&lang=ts"
export * from "./question-card-v2.vue?vue&type=script&lang=ts"
import style0 from "./question-card-v2.vue?vue&type=style&index=0&id=29efe74b&prod&lang=scss"
import style1 from "./question-card-v2.vue?vue&type=style&index=1&id=29efe74b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29efe74b",
  null
  
)

export default component.exports